import React, { Component } from 'react'
import shallowCompare from 'react-addons-shallow-compare'

class VariantTitleValue extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return shallowCompare(this, nextProps, nextState)
    }

    render() {
        const { item, variantIndex, itemIndex, deleteVariantOption, variantAdditionInProgress } = this.props

        // console.log('VariantTitleValue rendered', item.title)

        return (
            <div className="variant-item" data-new={item.new_value}>
                <input className="variant-value" type="text" name="variant_value" value={item.title} placeholder="Large, medium, small, etc."
                    onChange={e => this.props.changeVariantValue(e, variantIndex, itemIndex, item)}
                />
                <button className="icon-cross" disabled={variantAdditionInProgress} onClick={() => deleteVariantOption(variantIndex, itemIndex)}></button>
            </div>
        )
    }
}

export default VariantTitleValue



// WEBPACK FOOTER //
// ./src/components/admin/products/variants/VariantTitleValue.js